import { ref as b, computed as m, unref as r, watch as Z, nextTick as p } from "vue";
import j from "./index592.js";
import { buildPickerTable as ee } from "./index862.js";
import { useLocale as A } from "./index597.js";
import { castArray as N } from "./index765.js";
import { useNamespace as te } from "./index559.js";
import { isArray as ae } from "./index575.js";
import ne from "./index806.js";
const v = (t = "") => ["normal", "today"].includes(t), fe = (t, f) => {
  const { lang: g } = A(), h = b(), k = b(), w = b(), M = b(), C = b([[], [], [], [], [], []]);
  let D = !1;
  const o = t.date.$locale().weekStart || 7, u = t.date.locale("en").localeData().weekdaysShort().map((e) => e.toLowerCase()), x = m(() => o > 3 ? 7 - o : -o), E = m(() => {
    const e = t.date.startOf("month");
    return e.subtract(e.day() || 7, "day");
  }), _ = m(() => u.concat(u).slice(
    o,
    o + 7
  )), S = m(() => ne(r(O)).some((e) => e.isCurrent)), R = m(() => {
    const e = t.date.startOf("month"), a = e.day() || 7, n = e.daysInMonth(), s = e.subtract(1, "month").daysInMonth();
    return {
      startOfMonthDay: a,
      dateCountOfMonth: n,
      dateCountOfLastMonth: s
    };
  }), L = m(() => t.selectionMode === "dates" ? N(t.parsedValue) : []), F = (e, { count: a, rowIndex: n, columnIndex: s }) => {
    const { startOfMonthDay: d, dateCountOfMonth: c, dateCountOfLastMonth: l } = r(R), y = r(x);
    if (n >= 0 && n <= 1) {
      const i = d + y < 0 ? 7 + d + y : d + y;
      if (s + n * 7 >= i)
        return e.text = a, !0;
      e.text = l - (i - s % 7) + 1 + n * 7, e.type = "prev-month";
    } else
      return a <= c ? e.text = a : (e.text = a - c, e.type = "next-month"), !0;
    return !1;
  }, K = (e, { columnIndex: a, rowIndex: n }, s) => {
    const { disabledDate: d, cellClassName: c } = t, l = r(L), y = F(e, { count: s, rowIndex: n, columnIndex: a }), i = e.dayjs.toDate();
    return e.selected = l.find((Y) => Y.isSame(e.dayjs, "day")), e.isSelected = !!e.selected, e.isCurrent = P(e), e.disabled = d?.(i), e.customClass = c?.(i), y;
  }, $ = (e) => {
    if (t.selectionMode === "week") {
      const [a, n] = t.showWeekNumber ? [1, 7] : [0, 6], s = I(e[a + 1]);
      e[a].inRange = s, e[a].start = s, e[n].inRange = s, e[n].end = s;
    }
  }, O = m(() => {
    const { minDate: e, maxDate: a, rangeState: n, showWeekNumber: s } = t, d = r(x), c = r(C), l = "day";
    let y = 1;
    if (ee({ row: 6, column: 7 }, c, {
      startDate: e,
      columnIndexOffset: s ? 1 : 0,
      nextEndDate: n.endDate || a || n.selecting && e || null,
      now: j().locale(r(g)).startOf(l),
      unit: l,
      relativeDateGetter: (i) => r(E).add(i - d, l),
      setCellMetadata: (...i) => {
        K(...i, y) && (y += 1);
      },
      setRowMetadata: $
    }), s)
      for (let i = 0; i < 6; i++)
        c[i][1].dayjs && (c[i][0] = {
          type: "week",
          text: c[i][1].dayjs.week()
        });
    return c;
  });
  Z(
    () => t.date,
    async () => {
      var e;
      (e = r(h)) != null && e.contains(document.activeElement) && (await p(), await V());
    }
  );
  const V = async () => {
    var e;
    return (e = r(k)) == null ? void 0 : e.focus();
  }, P = (e) => t.selectionMode === "date" && v(e.type) && B(e, t.parsedValue), B = (e, a) => a ? j(a).locale(r(g)).isSame(t.date.date(Number(e.text)), "day") : !1, T = (e, a) => {
    const n = r(R).startOfMonthDay, s = r(x), d = n + s < 0 ? 7 + n + s : n + s, c = e * 7 + (a - (t.showWeekNumber ? 1 : 0));
    return t.date.startOf("month").subtract(d, "day").add(c, "day");
  }, U = (e) => {
    var a;
    if (!t.rangeState.selecting) return;
    let n = e.target;
    if (n.tagName === "SPAN" && (n = (a = n.parentNode) == null ? void 0 : a.parentNode), n.tagName === "DIV" && (n = n.parentNode), n.tagName !== "TD") return;
    const s = n.parentNode.rowIndex - 1, d = n.cellIndex;
    r(O)[s][d].disabled || (s !== r(w) || d !== r(M)) && (w.value = s, M.value = d, f("changerange", {
      selecting: !0,
      endDate: T(s, d)
    }));
  }, G = (e) => !r(S) && e?.text === 1 && v(e.type) || e.isCurrent, H = (e) => {
    D || r(S) || t.selectionMode !== "date" || W(e, !0);
  }, q = (e) => {
    e.target.closest("td") && (D = !0);
  }, z = (e) => {
    e.target.closest("td") && (D = !1);
  }, J = (e) => {
    !t.rangeState.selecting || !t.minDate ? (f("pick", { minDate: e, maxDate: null }), f("select", !0)) : (e >= t.minDate ? f("pick", { minDate: t.minDate, maxDate: e }) : f("pick", { minDate: e, maxDate: t.minDate }), f("select", !1));
  }, Q = (e) => {
    const a = e.week(), n = `${e.year()}w${a}`;
    f("pick", {
      year: e.year(),
      week: a,
      value: n,
      date: e.startOf("week")
    });
  }, X = (e, a) => {
    const n = a ? N(t.parsedValue).filter(
      (s) => s?.valueOf() !== e.valueOf()
    ) : N(t.parsedValue).concat([e]);
    f("pick", n);
  }, W = (e, a = !1) => {
    if (t.disabled) return;
    const n = e.target.closest("td");
    if (!n) return;
    const s = n.parentNode.rowIndex - 1, d = n.cellIndex, c = r(O)[s][d];
    if (c.disabled || c.type === "week") return;
    const l = T(s, d);
    switch (t.selectionMode) {
      case "range": {
        J(l);
        break;
      }
      case "date": {
        f("pick", l, a);
        break;
      }
      case "week": {
        Q(l);
        break;
      }
      case "dates": {
        X(l, !!c.selected);
        break;
      }
    }
  }, I = (e) => {
    if (t.selectionMode !== "week") return !1;
    let a = t.date.startOf("day");
    if (e.type === "prev-month" && (a = a.subtract(1, "month")), e.type === "next-month" && (a = a.add(1, "month")), a = a.date(Number.parseInt(e.text, 10)), t.parsedValue && !ae(t.parsedValue)) {
      const n = (t.parsedValue.day() - o + 7) % 7 - 1;
      return t.parsedValue.subtract(n, "day").isSame(a, "day");
    }
    return !1;
  };
  return {
    WEEKS: _,
    rows: O,
    tbodyRef: h,
    currentCellRef: k,
    // cellMatchesDate,
    // getDateOfCell,
    focus: V,
    isCurrent: P,
    isWeekActive: I,
    isSelectedCell: G,
    handlePickDate: W,
    handleMouseUp: z,
    handleMouseDown: q,
    handleMouseMove: U,
    handleFocus: H
  };
}, me = (t, {
  isCurrent: f,
  isWeekActive: g
}) => {
  const h = te("date-table"), { t: k } = A(), w = m(() => [
    h.b(),
    h.is("week-mode", t.selectionMode === "week" && !t.disabled)
  ]), M = m(() => k("el.datepicker.dateTablePrompt")), C = (o) => {
    const u = [];
    return v(o.type) && !o.disabled ? (u.push("available"), o.type === "today" && u.push("today")) : u.push(o.type), f(o) && u.push("current"), o.inRange && (v(o.type) || t.selectionMode === "week") && (u.push("in-range"), o.start && u.push("start-date"), o.end && u.push("end-date")), (o.disabled || t.disabled) && u.push("disabled"), o.selected && u.push("selected"), o.customClass && u.push(o.customClass), u.join(" ");
  }, D = (o) => [
    h.e("row"),
    { current: g(o) }
  ];
  return {
    tableKls: w,
    tableLabel: M,
    weekHeaderClass: h.e("week-header"),
    getCellClasses: C,
    getRowKls: D,
    t: k
  };
};
export {
  fe as useBasicDateTable,
  me as useBasicDateTableDOM
};
